export interface Credentials {
    email: string;
    password: string;
}

export interface Project {
    id: number;
    nameTH: string;
    nameEN: string;
    price: number;
    quantity: number;
    createdAt: string;
    updatedAt: string;
}

export interface ProjectCreate {
    id?: number;
    nameTH: string;
    nameEN: string;
    price: number;
    quantity: number;
}

export interface ProjectsResponse {
    data: Project[];
    total: number;
    page: number;
    limit: number;
    all?: boolean;
}

export interface Users {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    tel: string;
    role: string;
    createdAt: string;
    updatedAt: string;
    password: string;
    profileImgId: null | number;
    authType: string;
}

export interface UserCreate {
    id?: number;
    email: 'string';
    firstName: 'string';
    lastName: 'string';
    password: 'string';
    tel: 'string';
    role?: 'string';
    createdAt?: string | undefined;
}
export interface EventEmission {
    id?: number;
    name: string;
    subCategoryName?: string;
    summary?: string;
    summary_person?: string;
    location: string;
    startDate: string;
    endDate: string;
    eventPeriod: number;
    eventArea: number;
    eventSpace: number;
    eventMember: number;
    eventMemberOnline: number;
    eventForeignScale: number;
    eventOwner: string;
    subCategoryId: number;
    isEvent: string;
    userId: number;
    compensateStatus: string;
    createdAt: string;
    updatedAt: string;
    paymentStatus: string;
    emission: {
        summary: number;
        activity: {
            id?: number;
            area: number;
            name: string;
            duration: number;
            end_date: string;
            location: string;
            host_name: string;
            person_num: number;
            start_date: string;
            renew_energy: number | null;
            online_person: number;
            outdoor_space: number | null;
            foreign_percent: number;
        };
        activity_type: {
            id: number;
            name: string;
            section: string;
        };
        summary_person: number;
        emissions_sources: Array<{
            name: string;
            total: number;
            default: boolean;
            percentage: number;
            default_emissions: Array<{
                ef: number;
                days: number;
                name: string;
                air_ef: number;
                enable: boolean;
                foreign: number;
                persons: number;
                runtime_type: string;
            }>;
            specify_emissions: Array<{
                ef: number;
                name: string;
                set: number;
                enable: boolean;
                runtime_type: string;
                return_distance: number;
                return_passenger: number;
                outbound_distance: number;
                outbound_passenger: number;
            }>;
        }>;
    };
    subCategory?: ISubCategory;
}

export type EventUpdatePayload = Record<string, unknown>;

export interface ApiError {
    response?: {
        data?: unknown;
        status?: number;
    };
    message?: string;
}

export function isApiError(error: unknown): error is ApiError {
    return typeof error === 'object' && error !== null && 'response' in error;
}

export function getErrorResponse(error: unknown) {
    if (isApiError(error)) {
        return {
            data: error.response?.data,
            status: error.response?.status,
        };
    }
    return {
        data: null,
        status: 500,
    };
}
export interface ISubCategory {
    id: number;
    categoryId: number;
    name: string;
    nameEN: string;
    nameCH: string;
    createdAt: string;
    updatedAt: string;
}
export type EventDetails = {
    id: number;
    name: string;
    location: string;
    startDate: string;
    endDate: string;
    eventPeriod: number;
    eventArea: number;
    eventSpace: number;
    eventMember: number;
    eventMemberOnline: number;
    eventForeignScale: number;
    eventOwner: string;
    subCategoryId: number;
    isEvent: string;
    userId: number;
    compensateStatus: string;
    createdAt: string;
    updatedAt: string;
    paymentStatus: string;
    emission: {
        summary: number;
        activity: {
            id?: number;
            area: number;
            name: string;
            duration: number;
            end_date: string;
            location: string;
            host_name: string;
            person_num: number;
            start_date: string;
            renew_energy: number | null;
            online_person: number;
            outdoor_space: number | null;
            foreign_percent: number;
        };
        activity_type: {
            id: number;
            name: string;
            section: string;
        };
        summary_person: number;
        emissions_sources: Array<{
            name: string;
            total: number;
            default: boolean;
            percentage: number;
            default_emissions: Array<{
                ef: number;
                days: number;
                name: string;
                air_ef: number;
                enable: boolean;
                foreign: number;
                persons: number;
                runtime_type: string;
            }>;
            specify_emissions: Array<{
                ef: number;
                name: string;
                set: number;
                enable: boolean;
                runtime_type: string;
                return_distance: number;
                return_passenger: number;
                outbound_distance: number;
                outbound_passenger: number;
            }>;
        }>;
    };
    eventDetail: Array<{
        id: number;
        eventId: number;
        travel: number;
        foodAndDrink: number;
        rest: number;
        waste: number;
        electricityInside: number;
        electricityOutside: number;
        souvenirs: number;
        total: number;
        averagePerson: number;
        createdAt: string;
        updatedAt: string;
    }>;
    images: Array<string>;
};

export type EmissionsSourcesProps = {
    name: string;
    total: number;
    default: boolean;
    percentage: number;
    default_emissions: DefaultEmissionProps[];
    specify_emissions: SpecifyEmissionProps[];
};

export type DefaultEmissionProps = {
    ef: number;
    days: number;
    name: string;
    air_ef: number;
    enable: boolean;
    foreign: number;
    persons: number;
    runtime_type: string;
};

export type SpecifyEmissionProps = {
    ef: number;
    name: string;
    enable: boolean;
    runtime_type: string;
    return_distance: number;
    return_passenger: number;
    outbound_distance: number;
    outbound_passenger: number;
};

export interface IProfile {
    firstName?: string;
    lastName?: string;
    email: string;
    profileImgId?: string;
    image?: string;
    authType: string;
    mapId?: string;
    mobile?: string;
}

export interface IMiceForm {
    id?: number;
    subCategoryId?: string;
    name: string;
    startDate: string;
    endDate: string;
    eventPeriod: number;
    projectPlace?: string;
    outDoorPercent?: number;
    location: string;
    renewPercent: number;
    placeOther: string;
    eventArea: number;
    eventSpace: number;
    eventMember: number;
    eventMemberOnline: string;
    eventForeignScale: string;
    eventOwner: string;
    selectPlace?: string;
    subLocation?: string;
}

export interface IRegister {
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    passwordConfirm: string;
    tel: string;
    role: string;
}

export interface EmissionSourcesCarbon {
    summary: number;
    summary_person: number;
    emissions_sources: EmissionsSource[];
}

export interface EmissionsSource {
    [key: string]: any;
    name: string;
    name_en: string;
    name_ch: string;
    default: boolean;
    total: number;
    percentage: number;
    default_emissions: DefaultEmission[];
    specify_emissions: SpecifyEmission[];
    createdAt?: string;
}

export interface DefaultEmission {
    ef: number;
    enable: boolean;
    name: string;
    name_en: string;
    name_ch: string;
    runtime_type: string;
    air_ef?: number;
    days?: number;
    persons?: number;
    foreign?: number;
    area?: number;
    hours?: number;
    weight?: number;
    distance?: number;
}

export interface SpecifyEmission {
    [key: string]: any;
    ef: number;
    enable: boolean;
    name: string;
    name_en: string;
    name_ch: string;
    runtime_type: string;
    passengers_total?: number;
    distance_outbound_total?: number;
    set?: number;
    guests?: number;
    night?: number;
    weight?: number;
    kw_hour?: number;
    transport?: Transport[];
}

export interface Transport {
    weight: number;
    distance: number;
}

export interface CredentialsWithGoogle {
    email: 'string';
    name: 'string';
    googleId: 'string';
    photoUrl: 'string';
    fcmToken: 'string';
}

export interface IRoles {
    value: string;
    name: string;
}

export interface ILocation {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
    subLocation: ISubLocation[];
}

export interface ISubLocation {
    id: number;
    name: string;
    area: number;
    electricConsumption: number;
    createdAt: string;
    updatedAt: string;
    locationId: number;
}

export interface InvoiceFormData {
    fullName: string;
    address: string;
    taxId: string;
}
